module.exports = __webpack_public_path__ + "static/media/DSCF2137.904015db.jpg";